import { render } from "./ProjectComponent.vue?vue&type=template&id=0568bc9e&scoped=true"
import script from "./ProjectComponent.vue?vue&type=script&lang=js"
export * from "./ProjectComponent.vue?vue&type=script&lang=js"

import "./ProjectComponent.vue?vue&type=style&index=0&id=0568bc9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0568bc9e"]])

export default __exports__